<script lang="ts">
    import Odontograma from '../odontograma/Odontograma.svelte'

    export let data: Record<string, any>

    const stages = [
        { label: 'Pendente', color: '#FF9800' },
        { label: 'Concluído', color: '#4CAF50' },
        { label: 'Não tratar', color: '#607D8B' },
    ]
</script>

<Odontograma {stages} />
